'use strict'

export default [ {
    name:"identify",
    fields:[
      {
        name:"title"
      },
      {
        optional:true,
        name:"owner",
      },
      {
        name:"type",
        options:[{value:"Threat"},{value:"Opportunity"}]
      },
      {
        name:"category",
        options:[{value:"Time"},{value:"Cost"},{value:"Scope"},{value:"Quality"},{value:"Benefit"},{value:"Risk"}]
      },
      {
        optional:true,
        name:"cause",
        height:2,
        plainText: true,
      },
      {
        optional:true,
        name:"event",
        height:2,
        plainText: true,
      },
      {
        optional:true,
        name:"effect",
        height:2,
        plainText: true,
      },
    ]
  }, {
    name:"assess",
    fields: [
      { name: "assessment",
        type: "matrix",
        categories: [
          { name: "inherent" },
          { name: "residual" }
        ],
        fields: [
          {
            name:"impact",
            matrixType: "column",
            options:[
              {value:1,},
              {value:2,},
              {value:3,},
              {value:4,},
              {value:5,}
            ].reverse(), defaultValue:"1"
          },
          {
            name:"probability",
            matrixType: "row",
            options:[
              {value:1},
              {value:2},
              {value:3},
              {value:4},
              {value:5}
            ].reverse(), defaultValue:"1"
          }
        ]
      },
      { name:"impact",
        options:[{value:1},{value:2},{value:3},{value:4},{value:5}].reverse(), defaultValue:"1"
      },
      {
        name:"probability",
        options:[{value:1},{value:2},{value:3},{value:4},{value:5}].reverse(), defaultValue:"1"
      },
      {
        optional:true,
        name:"proximity",
      }
    ]
  }, {
    name:"plan",
    fields: [
      {
        name:"response",
        options:[{value:"Avoid"},{value:"Reduce"},{value:"Transfer"},{value:"Accept"},{value:"Share"},{value:"Enhance"},{value:"Exploit"},{value:"ContingencyPlan"}]
      },
      { name:"actionee"},
      { name:"action", height:3}
    ]
  }, {
    name: "implement",
    fields: [
      { name:"status", options:[{value:"Active"},{value:"Closed"}]},
      { name:"comments", height:3}
    ]
  }
];



// WEBPACK FOOTER //
// ./views/risk/formDefinition.js